import { Component, OnInit, OnDestroy } from '@angular/core';
import { DropdownComponent } from '../../ui/dropdown/dropdown.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DropdownItemTwoComponent } from '../../ui/dropdown/dropdown-item/dropdown-item.component-two';
import { AuthService } from '../../../services/auth.service';
import { Subscription } from 'rxjs';
import { AppFormatDatePipe } from '../../../pipe/format-date.pipe';

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  imports:[CommonModule,RouterModule,DropdownComponent,DropdownItemTwoComponent, AppFormatDatePipe]
})
export class UserDropdownComponent implements OnInit, OnDestroy {
  constructor(
    private authService: AuthService
  ) {}

  isOpen = false;
  username: string = '';
  email: string = '';
  todate: Date = new Date();
  isRoot = false;

  private authSubscription?: Subscription;

  ngOnInit() {
    this.loadUserData();
    // Subscribe to auth state changes to update user data when login/logout occurs
    this.authSubscription = this.authService.isAuthenticated$.subscribe(() => {
      this.loadUserData();
    });
  }

  ngOnDestroy() {
    this.authSubscription?.unsubscribe();
  }

  private loadUserData() {
    const user = this.authService.getCurrentUser();
    if (user) {
      this.username = user.name || '';
      this.email = user.email || '';
    }
    this.isRoot = this.authService.isRoot();
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }
}
